import { render, staticRenderFns } from "./SalesReportIcon.vue?vue&type=template&id=f17245fa&"
import script from "./SalesReportIcon.vue?vue&type=script&lang=js&"
export * from "./SalesReportIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f17245fa')) {
      api.createRecord('f17245fa', component.options)
    } else {
      api.reload('f17245fa', component.options)
    }
    module.hot.accept("./SalesReportIcon.vue?vue&type=template&id=f17245fa&", function () {
      api.rerender('f17245fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounting/income/SalesReportIcon.vue"
export default component.exports